import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1rem',
    width: '100vw',
    minHeight: 'calc(100vh - (64px + 1.5rem))',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    paddingTop: '1rem',
    gap: '1.25rem',
    width: '90vw',
    height: '100%',
    margin: '1rem',
    fontSize: '1.5rem',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    paddingTop: '1rem',
    gap: '0.5rem',
    '& > p': {
      maxWidth: '75%',
      textAlign: 'justify',
    },
  },

  answersContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '80vw',
    flexWrap: 'wrap',
    gap: '0.25rem',
    
  },

  answerDisplay: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    padding: '1rem',
    gap: '1rem',
    width: 'calc(40vw - 3rem)',
    height: '100%',
  },
}))

export default styles
